module.exports = __webpack_public_path__ + "static/img/aboutus_img2.5aa49b47.jpg";